import { Component, inject } from '@angular/core';
import { SpecialDealService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SpecialDealCreateDto,
  SpecialDealDto,
  SpecialDealExcelDownloadDto,
  SpecialDealUpdateDto,
} from '../proxy/controlling/dtos/special-deal';
import { SPECIALDEAL_CONFIG, SPECIALDEAL_FIELDS } from './special-deal.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-special-deal',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SpecialDealService, ConfirmationService],
  templateUrl: './special-deal.html',
  styleUrl: './special-deal.scss',
})
export class SpecialDeal extends BaseCrudComponent<
  SpecialDealDto,
  SpecialDealCreateDto,
  SpecialDealUpdateDto,
  SpecialDealExcelDownloadDto
> {
  service = inject(SpecialDealService);
  config = SPECIALDEAL_CONFIG;
  fields = SPECIALDEAL_FIELDS;

  protected prepareUpdateDto(data: any, selected: SpecialDealDto): SpecialDealUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SpecialDeal';
  }
}
